import actions from '../../actionTypes';

export default area => {
  return {
    type: actions.REMOVE_AREA,
    area
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/removeArea.js